import { render, staticRenderFns } from "./ClientComment.vue?vue&type=template&id=3aa3fa1c&scoped=true&"
import script from "./ClientComment.vue?vue&type=script&lang=js&"
export * from "./ClientComment.vue?vue&type=script&lang=js&"
import style0 from "./ClientComment.vue?vue&type=style&index=0&id=3aa3fa1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa3fa1c",
  null
  
)

export default component.exports